import { render, staticRenderFns } from "./_base-course-dashboard-question-show.vue?vue&type=template&id=d0911168"
import script from "./_base-course-dashboard-question-show.vue?vue&type=script&lang=js"
export * from "./_base-course-dashboard-question-show.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports